import MultiLinkedBookkeepingList from "components/Picker/Bookkeeping/MultiLinkedBookkeepingList";
import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";
import React from "react";
import { LinkedBookkeepingsPanel } from "./LinkedBookkeepingsPanel";

interface Props {
  bankAccountId: number;
}

export const LinkedBookkeepingsBankAccountPanel = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);

  const onAddBookkeepings = async (newBookkeepings: server.dto.BookkeepingSmall[]) => {
    await window.CoreApi.BankAccount.LinkBookkeepings({
      bankAccountId: props.bankAccountId,
      bookkeepingIds: newBookkeepings.map(bk => bk.bookkeepingId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const unlinkBookkeeping = async (bookkeeping: server.dto.BookkeepingSmall) => {
    await window.CoreApi.BankAccount.UnlinkBookkeepings({
      bankAccountId: props.bankAccountId,
      bookkeepingIds: [bookkeeping.bookkeepingId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedBookkeepingsPanel<server.dto.PaginatedLinkedBookkeepingsToBankAccountInstruction>
      queryKey={queryKeyIncrement.toString()}
      perPage={8}
      title={RESX.Bookkeeping.Bookkeepings}
      noSelectionLabel={RESX.Bookkeeping.AssignAtLeastOneBookkeeping}
      listFunc={window.CoreApi.BankAccount.PaginatedLinkedBookkeepings}
      initialInstruction={{
        bankAccountId: props.bankAccountId,
        whereInOrNotIn: "in",
        keyword: "",
        page: 1,
        perPage: 8,
      }}
      onDelete={unlinkBookkeeping}
      onAdd={() => setIsNewModalOpen(true)}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Bookkeeping.Bookkeepings}
      modalSize="small"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddBookkeepings}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiLinkedBookkeepingList
        initialInstruction={{
          bankAccountId: props.bankAccountId,
          whereInOrNotIn: "notIn",
          keyword: "",
          page: 1,
          perPage: 20,
        }}
        listFunc={window.CoreApi.BankAccount.PaginatedLinkedBookkeepings}
        onChange={setEditedValue}
        value={editedValue}
      />}
    />}
  </>
};